import { render, staticRenderFns } from "./CourseView.html?vue&type=template&id=4dadcac8&scoped=true&external"
import script from "./CourseView.ts?vue&type=script&lang=ts&external"
export * from "./CourseView.ts?vue&type=script&lang=ts&external"
import style0 from "./CourseView.scss?vue&type=style&index=0&id=4dadcac8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dadcac8",
  null
  
)

export default component.exports